import { Heading, SkeletonText } from "@chakra-ui/react";
import { useContext } from "react";

import { ContributionContext } from "../context";

export function Title() {
  const { cardHeading, isLoaded, variant, headingId } =
    useContext(ContributionContext);

  if (!isLoaded) {
    return (
      <SkeletonText w="full" noOfLines={variant === "horizontal" ? 2 : 3} />
    );
  }

  return (
    <Heading
      as="h2"
      fontSize="md"
      fontWeight="semibold"
      data-testid="card-headingText"
      noOfLines={variant === "horizontal" ? 2 : 3}
      id={headingId}
    >
      {cardHeading}
    </Heading>
  );
}
